import { Component, OnInit, ViewChild, Input, ElementRef, OnChanges, SimpleChange, Output, EventEmitter, ChangeDetectorRef, AfterViewInit, Directive, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { Subscription, ISubscription } from 'rxjs/Subscription';
import { AppService } from '../../../../app.service';
import { DashboardService } from '../../dashboard.service';
import { equipmentVwMdl, SearchItem, Side, ComponentTableInspectionViewModel, ComponentViewViewModel, ComponentType, ComponentActionViewModel } from '../../../../entities';
import { AppUris, selectionChangeForDetection, PageComponent } from '../../../../entities/app-config/model';
import { GlobalLabels, CurrentSelection, SelectionLists, Customer, JobSite, Equipment, UserSelectedIds } from '../../../../entities/global/model';
import { DatePipe } from '@angular/common';
import { TranslateService } from '../../../../translate';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from "@angular/common";
import { trigger, style, animate, transition } from '@angular/animations';
import { NotificationsService } from 'angular2-notifications';
import { ConditionalExpr } from '@angular/compiler';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { DataSource } from '@angular/cdk/table';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { CryptoService } from '../../../../services/crypto.service';

export enum TableView {
    EquipmentView = 0,
    ComponentView = 1,
    WearRatesView = 2,
}
export enum SearchMode {
    Single = 0,
    Multiple = 1
}
export class OutstantingActionStatus {
    public ComponentId: number = 0;
    public ActionType: number = 0;
    public ActionTitle: string = '';
    public ActionStatus: string = '';
    public CssClass: string = '';
}
export class TrackRollerWorn {
    public ComponentId: number = 0;
    public Worn: number = 0;
    public CssClass: string = '';
}

export enum ComponentColumnHeader {
    Sides = 0,
    Link = 1,
    HoursOnLink = 2,
    Bush = 3,
    BushTurned = 4,
    Shoe = 5,
    FrontIdler = 6,
    RearIdler = 7,
    Sprocket = 8,
    CarrierRoller_1 = 9,
    CarrierRoller_2 = 10,
    CarrierRoller_3 = 11,
    CarrierRoller_4 = 12,
    CarrierRoller_5 = 13,
    TrackRoller_1 = 14,
    TrackRoller_2 = 15,
    TrackRoller_3 = 16,
    TrackRoller_4 = 17,
    TrackRoller_5 = 18,
    TrackRoller_6 = 19,
    TrackRoller_7 = 20,
    TrackRoller_8 = 21,
    TrackRoller_9 = 22,
    TrackRoller_10 = 23,
    TrackRoller_11 = 24,
    TrackRoller_12 = 25,
    TrackRoller_13 = 26,
    TrackRoller_14 = 27,
    TrackRoller_15 = 28,
    TrackElon = 29,


}

@Component({
    selector: 'app-component-wear',
    templateUrl: './component-wear.component.html',
    styleUrls: ['./component-wear.component.scss'],
    animations: [
        trigger(
            'fadeInOut', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('500ms', style({ opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ opacity: 1 }),
                    animate('500ms', style({ opacity: 0 }))
                ])
            ]
        )]
})
export class ComponentWearComponent implements OnInit {
    @Input() UriConfig: AppUris;
    equipmentDataLoading = true;
    _currentSelection: CurrentSelection = new CurrentSelection();
    _currentSearchItemSelection: SearchItem[] = [];
    _loading = 0;
    selectionSubscription: Subscription;
    selectionSearchItemsSubscription: Subscription;
    translateSubscription: Subscription;
    componentViewListBySearchItemsSubscription: Subscription;
    getExportClickedSubscription: Subscription;
    userLanguage = 'english';
    _tableView: TableView = TableView.ComponentView;
    displayedColumns = ['modelImage', 'EvalL', 'EvalR', 'customer', 'serial', 'unit','addiunit', 'make', 'model', 'family', 'smu', 'ltd', 'lastInspectionDate'];
    equipmentList: equipmentVwMdl[] = [];
    eqTableDatabase: EqTableDatabase | null;
    dataSource: EqTableDataSource | null;
    _equipmentRequestToken = 0;
    _componentRequestToken = 0;
    _wearRatesRequestToken = 0;
    componentDisplayedColumns = ['Serial', 'Unit','AddiUnit', 'Model', 'Site','inspector' ,'CurrentSMU',  'sides', 'Link','TrackElon', 'Bush', 'BushTurned', 'Shoe', 'FrontIdler', 'RearIdler', 'Sprocket', 'CarrierRoller_1', 'CarrierRoller_2', 'CarrierRoller_3', 'CarrierRoller_4', 'CarrierRoller_5', 'TrackRoller_1', 'TrackRoller_2',
     'TrackRoller_3', 'TrackRoller_4', 'TrackRoller_5', 'TrackRoller_6', 'TrackRoller_7', 'TrackRoller_8',
     'TrackRoller_9', 'TrackRoller_10', 'TrackRoller_11', 'TrackRoller_12', 'TrackRoller_13', 'TrackRoller_14','TrackRoller_15'];
    equipmentComponentViewList: ComponentTableInspectionViewModel[] = [];
    componentViewDatabase: ComponentViewTableDatabase | null;
    componentViewDataSource: ComponentViewTableDataSource | null;
    routeSubscription: ISubscription;

    _searchMode: SearchMode = SearchMode.Single;

    viewingEquipmentDetails = false;
    @ViewChild('paginator') paginator: MatPaginator;
    @ViewChild('componentPaginator') componentPaginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;
    loadSize = 100;
    loadingPage = 1;
    searchCount = 0;
    _currentSort: Sort = { active: 'LastInspectionDate', direction: 'desc' };
    filterVisible = false;
    @Input() routeItemId: number;
    selectedEquipmentId = 0;
    selectedEquipmentRow: equipmentVwMdl = new equipmentVwMdl();
    enableTab:boolean=false
    constructor(private _location: Location, private _route: ActivatedRoute, private _router: Router, private _moduleService: DashboardService,
        private _appService: AppService, private ref: ChangeDetectorRef,
        private _translate: TranslateService,
        private _notification: NotificationsService,
        private elRef: ElementRef,
        public dialog: MatDialog,
        private readonly _pref: PreferencesService,
        private _crypto: CryptoService) {
    }
    ngOnInit() {
        this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 10));
        if (this._route.snapshot.params.page != null)
            this.loadingPage = this._route.snapshot.params.page;
        this.routeSubscription = this._location.subscribe(l => {
            const page = l.url.split('/');
            this.retrieveEquipmentsComponentViewBySearchItems(Number(page[2]) + 1, this.loadSize);
        });
        this._appService.setPageTitle('Dashboard | Wear Rate Overview');
        this._currentSelection = this._appService.getLastSelection();
        this._currentSearchItemSelection = this._appService.getLastSelectionSearchItems();
        this.enableTab=this._appService.getEnableSearch()

        this.selectionSubscription = this._appService.getSelection().subscribe(message => setTimeout(() => { this.selectionChangedDetected(message); }, 10));
        this.selectionSearchItemsSubscription = this._appService.getSelectionSearchItems().subscribe(message => setTimeout(() => { this.selectionSearchItemChangedDetected(message); }, 10));
        this.getExportClickedSubscription = this._moduleService.getExportClicked().subscribe(item => {
            if (item === 1) // 1 means export PDF, at the moment there is only one export option
               {
                this._moduleService.SaveSearchItemsComponentViewForExport(this.loadingPage, this.loadSize, this._currentSearchItemSelection, this._equipmentRequestToken, this._currentSort.active, this._currentSort.direction).subscribe(searchId => { this.printBySearchId(searchId); }, error => console.error(error), () => { });
               } 
       
                else if(item===2){
                    //this.exportCSVClicked()
                    this.retrieveComponentForReporting(0,0)
                }
            }, error => console.error(error), () => { });
       
    }
    ngAfterViewInit(){
        this.eqTableDatabase = new EqTableDatabase(this.equipmentList);
        this.dataSource = new EqTableDataSource(this.eqTableDatabase, this.paginator);

        this.componentViewDatabase = new ComponentViewTableDatabase(this.equipmentComponentViewList);
        this.componentViewDataSource = new ComponentViewTableDataSource(this.componentViewDatabase, this.componentPaginator);
        this.toggleView(TableView.ComponentView);
    }
    exportCSVClicked(){
        console.log("CSV___DONE")
        this.downloadFile(this.componentViewDataSource)
    }

     //download csv file
     downloadFile(data: any) {
     
        console.log("data", data)
     
        let _data = []
        data.map(p => {
          let _o = {}
          for (var key in p) {
            if (p.hasOwnProperty(key)) {
     
              if(key == "Id"){
                _o["Equipment ID"] = p[key] 
              }else if(key == "Serial"){
                _o["Serial"] = p[key];
              }else if(key == "AddiUnit"){
                _o["AddiUnit"] = p[key];
              }else if(key == "Model"){
                _o["Model"] = p[key]
              }else if(key == "Site"){
                _o["Site"] = p[key] 
              }else if(key == "W_LinkL"){
                _o["LinkL"] = p[key];
              }else if(key == "W_LinkR"){
                _o["LinkR"] = p[key];
              }else if(key == "W_BushL"){
                _o["BushL"] = p[key]
              }else if(key == "W_BushR"){
                _o["BushR"] = p[key];
              }else if(key == "W_ShoeL"){
                _o["ShoeL"] = p[key] 
              }else if(key == "W_ShoeR"){
                _o["ShoeR"] = p[key];
              }else if(key == "W_FIdlerL"){
                _o["Front Idler L"] = p[key];
              }else if(key == "W_FIdlerR"){
                _o["Front Idler R"] = p[key]
              }else if(key == "W_RIdlerL"){
                _o["Rear Idler L"] = p[key];
              }else if(key == "W_RIdlerR"){
                _o["Rear Idler R"] = p[key];
              }else if(key == "W_SprocketL"){
                _o["SprocketL"] = p[key]
              }else if(key == "W_SprocketR"){
                _o["SprocketR"] = p[key] 
              }else if(key == "W_CR1L"){
                _o["Carrier Roller 1 L"] = p[key];
              }else if(key == "W_CR1R"){
                _o["Carrier Roller 1 R"] = p[key];
              }else if(key == "W_CR2L"){
                _o["Carrier Roller 2 L"] = p[key]
              }else if(key == "W_CR2R"){
                _o["Carrier Roller 2 R"] = p[key];
              }else if(key == "W_CR3L"){
                _o["Carrier Roller 3 L"] = p[key];
              }else if(key == "W_CR3R"){
                _o["Carrier Roller 3 R"] = p[key]
              }else if(key == "W_CR4L"){
                _o["Carrier Roller 4 L"] = p[key] 
              }else if(key == "W_CR4R"){
                _o["Carrier Roller 4 R"] = p[key];
              }else if(key == "W_CR5L"){
                _o["Carrier Roller 5 L"] = p[key];
              }else if(key == "W_CR5R"){
                _o["Carrier Roller 5 R"] = p[key]
              }else if(key == "W_TR1L"){
                _o["Track Roller 1 L"] = p[key];
              }else if(key == "W_TR1R"){
                _o["Track Roller 1 R"] = p[key]
              }else if(key == "W_TR2L"){
                _o["Track Roller 2 L"] = p[key]
              }else if(key == "W_TR2R"){
                _o["Track Roller 2 R"] = p[key]
              }else if(key == "W_TR3L"){
                _o["Track Roller 3 L"] = p[key]
              }else if(key == "W_TR3R"){
                _o["Track Roller 3 R"] = p[key]
              }else if(key == "W_TR4L"){
                _o["Track Roller 4 L"] = p[key]
              }else if(key == "W_TR4R"){
                _o["Track Roller 4 R"] = p[key]
              }else if(key == "W_TR5L"){
                _o["Track Roller 5 L"] = p[key]
              }else if(key == "W_TR5R"){
                _o["Track Roller 5 R"] = p[key]
              }else if(key == "W_TR6L"){
                _o["Track Roller 6 L"] = p[key]
              }else if(key == "W_TR6R"){
                _o["W_TR6R"] = p[key]
              }else if(key == "W_TR7L"){
                _o["Track Roller 7 L"] = p[key]
              } else if(key == "W_TR7R"){
                _o["Track Roller 7 R"] = p[key]
              }else if(key == "W_TR8L"){
                _o["Track Roller 8 L"] = p[key]
              }else if(key == "W_TR8R"){
                _o["Track Roller 8 R"] = p[key]
              }else if(key == "W_TR9L"){
                _o["Track Roller 9 L"] = p[key]
              }else if(key == "W_TR9R"){
                _o["W_TRTrack Roller 9 R"] = p[key]
              } else if(key == "W_TR10L"){
                _o["Track Roller 10 L"] = p[key]
              }else if(key == "W_TR10R"){
                _o["Track Roller 10 R"] = p[key]
              }else if(key == "W_TR11L"){
                _o["Track Roller 11 L"] = p[key]
              }else if(key == "W_TR11R"){
                _o["Track Roller 11 R"] = p[key]
              }else if(key == "W_TR12L"){
                _o["Track Roller 12 L"] = p[key]
              }else if(key == "W_TR12R"){
                _o["Track Roller 12 R"] = p[key]
              }else if(key == "W_TR13L"){
                _o["Track Roller 13 L"] = p[key]
              }else if(key == "W_TR13R") {
                _o["Track Roller 13 R"] = p[key]
              }else if(key == "W_TR14L"){
                _o["Track Roller 14 L"] = p[key]
              }else if(key == "W_TR14R"){
                    _o["Track Roller 14 R"] = p[key]
              }else if(key == "W_TR15L"){
                    _o["Track Roller 15 L"] = p[key]
              }else if(key == "W_TR15R"){
                    _o["Track Roller 15 R"] = p[key]
              }

            }
        }
     
        _data.push(_o)
        })
     
        const replacer = (key, value) => value === null ? '' : value; 
        const header = Object.keys(_data[0]);
        let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
        csv.unshift(header.join(','));
        let csvArray = csv.join('\r\n');
        var a = document.createElement('a');
        var blob = new Blob([csvArray], { type: 'text/csv' }),
          url = window.URL.createObjectURL(blob);
     
        a.href = url;
        a.download = `Wear_Rate_Overview.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    cancelSearch() {
        if (this.componentViewListBySearchItemsSubscription != null)
            this.componentViewListBySearchItemsSubscription.unsubscribe();
        this._loading = 0;
    }

    toggleView(event: any) {
        if (event.value === this._tableView)
            return;
        this._tableView = event.value;

        if (this._tableView === TableView.EquipmentView) {
            this._componentRequestToken = 0;
            this._equipmentRequestToken = 0;
            this._wearRatesRequestToken = 0;
            this.retrieveEquipmentsBySearchItems(1, this.loadSize);
        } else if (this._tableView === TableView.ComponentView) {
            this._componentRequestToken = 0;
            this._equipmentRequestToken = 0;
            this._wearRatesRequestToken = 0;
            this.retrieveEquipmentsComponentViewBySearchItems(this.loadingPage, this.loadSize);
        }
        else {
            this._componentRequestToken = 0;
            this._equipmentRequestToken = 0;
            this._wearRatesRequestToken = 0;
            this.retrieveEquipmentsComponentViewBySearchItems(this.loadingPage, this.loadSize);
        }
    }
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.selectionSubscription.unsubscribe();
        this.selectionSearchItemsSubscription.unsubscribe();
        this.componentViewListBySearchItemsSubscription.unsubscribe();
        this.getExportClickedSubscription.unsubscribe();
        if (this.routeSubscription != null)
            this.routeSubscription.unsubscribe();
    }

    handleHideDetails(visible: boolean) {
        this.viewingEquipmentDetails = visible;
    }

    updateUserLang(lang: string) {
        this.userLanguage = lang;
        this.ref.detectChanges();
    }

    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
    }

    pageChanged(event: PageEvent) {
        // console.log(event);
        if (this._searchMode === SearchMode.Single)
            this.retrieveEquipmentsByCondition(event.pageIndex + 1, event.pageSize);
        else
            this.retrieveEquipmentsBySearchItems(event.pageIndex + 1, event.pageSize);
    }

    componentPageChanged(event: PageEvent) {
        this.retrieveEquipmentsComponentViewBySearchItems(event.pageIndex + 1, event.pageSize);
        this._router.navigate(['wears', (event.pageIndex + 1)]);
    //   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //         this._router.navigate(['wears', (event.pageIndex + 1)]);
    //     }else{             
    //       window.open('/wears/' + (event.pageIndex + 1), '_blank');
         
    //     }
    // });
    }
    selectionChangedDetected(current: CurrentSelection) {
        if (this._loading !== 0) {
            return;
        }
        this._currentSelection = current;
        this._searchMode = SearchMode.Single;
        this.retrieveEquipmentsByCondition(1, this.loadSize);
    }

    selectionSearchItemChangedDetected(current: SearchItem[]) {
        this.cancelSearch();
        this._router.navigate(['wears', 1]);

    //  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //         this._router.navigate(['wears', 1]);
    //     }else{             
    //       window.open('/wears/' + 1, '_blank');
         
    //     }
    // });
        /*if (this._loading != 0) {
            return;
        }*/        
        this._currentSearchItemSelection = current;
        this.enableTab=this._appService.getEnableSearch()
        this._searchMode = SearchMode.Multiple;
        if (this._tableView === TableView.EquipmentView)
            this.retrieveEquipmentsBySearchItems(1, this.loadSize);
        else
            this.retrieveEquipmentsComponentViewBySearchItems(1, this.loadSize);
    }

    retrieveEquipmentsByCondition(pageNo: number, pageSize: number) {
        const userSelectedParam = new UserSelectedIds();
        this.equipmentList = [];
        this.eqTableDatabase.dataChange.next(this.equipmentList);

        userSelectedParam.CustomerId = this._currentSelection.customer.Id;
        userSelectedParam.JobSiteId = this._currentSelection.jobSite.Id;
        userSelectedParam.EquipmentId = this._currentSelection.equipment.Id;
        userSelectedParam.MakeId = this._currentSelection.make.Id;
        userSelectedParam.FamilyId = this._currentSelection.family.Id;
        userSelectedParam.ModelId = this._currentSelection.model.Id;

        this._loading++;
        this._moduleService.getEquipmentCountByCondition(userSelectedParam).subscribe(counts => {
            this._loading++;
            this._moduleService.getEquipmentListByCondition(pageNo, pageSize, userSelectedParam).subscribe(result => {
                this.equipmentList.push(...result);
                this.eqTableDatabase.dataChange.next(this.equipmentList);
                this.paginator.length = counts;
                this.paginator.pageIndex = pageNo - 1;
                this.paginator.pageSize = pageSize;
                this.loadSize = pageSize;
                this.ref.detectChanges();
            }, error => { console.log(error); }, () => { this._loading--; });
        }, error => { console.log(error); }, () => { this._loading--; });
    }


    retrieveEquipmentsBySearchItems(pageNo: number, pageSize: number) {
        this.loadingPage = pageNo;
        this.equipmentList = [];
        this.eqTableDatabase.dataChange.next(this.equipmentList);
        this._loading++;
        this.enableTab=this._appService.getEnableSearch()
        this._equipmentRequestToken++;      
        this._moduleService.getEquipmentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._equipmentRequestToken, this._currentSort.active, this._currentSort.direction)
            .subscribe(result => {
                if (result._clientReqId !== this._equipmentRequestToken) {
                    console.error('Operarion Cancelled!');
                    return;
                }
                this._moduleService.sendExportStatus(1);
                this.equipmentList.push(...result.ResultList);
                this.eqTableDatabase.dataChange.next(this.equipmentList);
                this.paginator.length = result.SearchResult.Total;
                this.paginator.pageIndex = pageNo - 1;
                this.paginator.pageSize = pageSize;
                // console.log('equipment paginator:', this.paginator);
                this.loadSize = pageSize;
                this.ref.detectChanges();
            }, error => { console.log(error); }, () => { this._loading--; });
    }

    retrieveEquipmentsComponentViewBySearchItems(pageNo: number, pageSize: number) {
        this.loadingPage = pageNo;
        this.cancelSearch();
        this.equipmentComponentViewList = [];
        this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
        this._loading++;
        this.enableTab=this._appService.getEnableSearch()
        this._componentRequestToken++;     
        this.componentViewListBySearchItemsSubscription = this._moduleService.getComponentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._componentRequestToken, this._currentSort.active, this._currentSort.direction)
            .subscribe(result => {
                if (result._clientReqId !== this._componentRequestToken) {
                    console.error('Operation Cancelled!');
                    return;
                }
                this._moduleService.sendExportStatus(2);
                // console.log('result.ResultList', result.ResultList);
                this.equipmentComponentViewList.push(...result.ResultList);
                this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
                this.componentPaginator.length = result.SearchResult.Total;
                this.componentPaginator.pageIndex = pageNo - 1;
                this.componentPaginator.pageSize = pageSize;
                this.loadSize = pageSize;
                this.ref.detectChanges();
                this.equipmentDataLoading = false;
                this._moduleService.getRecommendedActions(result.ResultList.map(m => m.Id)).subscribe(res => {
                    ['fleet-condition-widget', 'inspections-performed-widget', 'cost-of-repairs-monthly-widget', 'components-on-eval-widget', 'app-inspections-due-widget'].forEach(m => {
                        this._appService.sendWidgetTrigger(m);
                    });
                    this.equipmentComponentViewList.forEach(m => {
                        const filtered = res.find(k => k.EquipmentId === m.Equipment.Id);
                        if (filtered) {
                            m.LastInspection.RecommendedActions = filtered.RecommendedActions;
                            m.Components.forEach(k => {
                                k.Actions = filtered.CompletedActions.filter(p => p.ComponentId === k.Id);
                            });
                        }
                        //AES256
                        if (m?.LastInspection.Inspector && m?.LastInspection.Inspector.length > 0) {
                            m.LastInspection.Inspector = this._crypto.decrypt(m.LastInspection.Inspector);
                        }
                    });
                    this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
                        }, error => console.error(error), () => { });
            }, error => { console.log(error); this.equipmentDataLoading = false; this._loading--; }, () => { this._loading--; this.equipmentDataLoading = false; });
    }


    retrieveComponentForReporting(pageNo: number, pageSize: number) {
        this.loadingPage = pageNo;
        pageSize = 0;
        this.cancelSearch();
        this.equipmentComponentViewList = [];
        this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
        this._loading++;
        this.enableTab=this._appService.getEnableSearch()
        this._componentRequestToken++;     
        this.componentViewListBySearchItemsSubscription = this._moduleService.getComponentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._componentRequestToken, this._currentSort.active, this._currentSort.direction)
            .subscribe(result => {
                if (result._clientReqId !== this._componentRequestToken) {
                    console.error('Operation Cancelled!');
                    return;
                }
                this._moduleService.sendExportStatus(2);
                // console.log('result.ResultList', result.ResultList);
                this.equipmentComponentViewList.push(...result.ResultList);
                this._moduleService.getRecommendedActions(result.ResultList.map(m => m.Id)).subscribe(res => {
                    ['fleet-condition-widget', 'inspections-performed-widget', 'cost-of-repairs-monthly-widget', 'components-on-eval-widget', 'app-inspections-due-widget'].forEach(m => {
                        this._appService.sendWidgetTrigger(m);
                    });
                    this.equipmentComponentViewList.forEach(m => {
                        const filtered = res.find(k => k.EquipmentId === m.Equipment.Id);
                        if (filtered) {
                            m.LastInspection.RecommendedActions = filtered.RecommendedActions;
                            m.Components.forEach(k => {
                                k.Actions = filtered.CompletedActions.filter(p => p.ComponentId === k.Id);
                            });
                        }
                    });
                    this.downloadFile(this.equipmentComponentViewList);
                        }, error => console.error(error), () => { });
            }, error => { console.log(error); this.equipmentDataLoading = false; this._loading--; }, () => { this._loading--; this.equipmentDataLoading = false; });
    }

    

    showFilter() {
        this.filterVisible = true;
    }
    rowClicked(row: any) {
        // this.selectedEquipmentId = row.Id;
        // this.selectedEquipmentRow = row;
        // this.viewingEquipmentDetails = true;
        // this._router.navigate(['/equipment', row.Id]);
        window.open('/equipment/' + row.Id, '_blank');
    //    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //       this._router.navigate(['/equipment', row.Id]);
    //     }else{             
    //         window.open('/equipment/' + row.Id, '_blank');
         
    //     }
    // });
    }

    openEquipmentNewTab(event, equipmentId) {
        event.stopPropagation();
        window.open('/equipment/' + equipmentId, '_blank');

    //   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //       this._router.navigate(['/equipment', equipmentId]);
    //     }else{             
    //         window.open('/equipment/' + equipmentId, '_blank');
         
    //     }
    // });
    }

    componentRowClicked(row: ComponentTableInspectionViewModel) {
        // console.log(row);
        const equipment = new equipmentVwMdl();
        equipment.customerId = row.Equipment.Customer.Id;
        equipment.customerName = row.Equipment.Customer.Title;
        equipment.EvalL = this._appService.getEvalCode(Math.max(...row.Components.filter(m => m.Side === Side.Left).map(m => m.Worn)));
        equipment.EvalR = this._appService.getEvalCode(Math.max(...row.Components.filter(m => m.Side === Side.Right).map(m => m.Worn)));
        equipment.family = row.Equipment.MakeModelFamily.Family.Title;
        equipment.familyId = row.Equipment.MakeModelFamily.Family.Id;
        equipment.Id = row.Equipment.Id;
        equipment.jobsiteId = row.Equipment.JobSite.Id;
        equipment.jobsiteName = row.Equipment.JobSite.Title;
        equipment.lastInspectionDate = this._appService.formatDate(row.LastInspection.Date);
        equipment.lastInspectionId = row.LastInspection.Id;
        equipment.ltd = row.LastInspection.SMU;
        equipment.make = row.Equipment.MakeModelFamily.Make.Title;
        equipment.makeId = row.Equipment.MakeModelFamily.Make.Id;
        equipment.model = row.Equipment.MakeModelFamily.Model.Title;
        equipment.modelId = row.Equipment.MakeModelFamily.Model.Id;
        equipment.overAllEvalNumber = Math.max(...row.Components.map(m => m.Worn));
        equipment.quoteId = 0;
        equipment.serial = row.Equipment.Serial;
        equipment.unit = row.Equipment.Unit;
        equipment.smu = row.Equipment.SMU;
        equipment.quoteId = row.LastInspection.QuoteId;
        this.selectedEquipmentId = equipment.Id;
        this.selectedEquipmentRow = equipment;
        this.viewingEquipmentDetails = true;
    }

    goToOldHistory(Id: number) {
        window.location.href = this.UriConfig.oldUCUri + 'Track/Undercarriagehistory.aspx?equip_auto=' + Id.toString();
    }

    getComponentValue(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[]): string {
        switch (componentHeader) {
            case ComponentColumnHeader.Link:
                return this.getComponentworn(ComponentType.Link, side, components, 0, false, false).toString();
            case ComponentColumnHeader.Bush:
                return this.getComponentworn(ComponentType.Bushing, side, components, 0, false, false).toString();
            case ComponentColumnHeader.Shoe:
                return this.getComponentworn(ComponentType.Shoe, side, components, 0, false, false).toString();
            case ComponentColumnHeader.FrontIdler:
                return this.getComponentworn(ComponentType.Idler, side, components, 1, false, false).toString();
            case ComponentColumnHeader.RearIdler:
                return this.getComponentworn(ComponentType.Idler, side, components, 2, false, false).toString();
            case ComponentColumnHeader.Sprocket:
                return this.getComponentworn(ComponentType.Sprocket, side, components, 0, false, false).toString();
            case ComponentColumnHeader.CarrierRoller_1:
                return this.getComponentworn(ComponentType.CarrierRoller, side, components, 1, false, false).toString();
            case ComponentColumnHeader.CarrierRoller_2:
                return this.getComponentworn(ComponentType.CarrierRoller, side, components, 2, false, false).toString();
            case ComponentColumnHeader.CarrierRoller_3:
                return this.getComponentworn(ComponentType.CarrierRoller, side, components, 3, false, false).toString();
            case ComponentColumnHeader.CarrierRoller_4:
                return this.getComponentworn(ComponentType.CarrierRoller, side, components, 4, false, false).toString();
            case ComponentColumnHeader.CarrierRoller_5:
                return this.getComponentworn(ComponentType.CarrierRoller, side, components, 5, false, false).toString();

            case ComponentColumnHeader.TrackRoller_1:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 1, false, false).toString();
            case ComponentColumnHeader.TrackRoller_2:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 2, false, false).toString();
            case ComponentColumnHeader.TrackRoller_3:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 3, false, false).toString();
            case ComponentColumnHeader.TrackRoller_4:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 4, false, false).toString();
            case ComponentColumnHeader.TrackRoller_5:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 5, false, false).toString();
            case ComponentColumnHeader.TrackRoller_6:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 6, false, false).toString();
            case ComponentColumnHeader.TrackRoller_7:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 7, false, false).toString();
            case ComponentColumnHeader.TrackRoller_8:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 8, false, false).toString();

            case ComponentColumnHeader.TrackRoller_9:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 9, false, false).toString();
            case ComponentColumnHeader.TrackRoller_10:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 10, false, false).toString();
            case ComponentColumnHeader.TrackRoller_11:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 11, false, false).toString();
            case ComponentColumnHeader.TrackRoller_12:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 12, false, false).toString();
            case ComponentColumnHeader.TrackRoller_13:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 13, false, false).toString();
            case ComponentColumnHeader.TrackRoller_14:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 14, false, false).toString();
            case ComponentColumnHeader.TrackRoller_15:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 15, false, false).toString();
            case ComponentColumnHeader.TrackElon:
                return this.getComponentworn(ComponentType.TrackElongation, side, components, 1, false, false).toString();

            case ComponentColumnHeader.BushTurned:
                if (this.checkComponetAction(ComponentType.Bushing, side, components, 1, 12)) // 12 = Turn Pins & bushing
                    return this.Translate('Yes');
                return this.Translate('No');
            default:
                return '';
        }
    }

    getComponentHours(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[],row:ComponentTableInspectionViewModel): string {
        switch (componentHeader) {
            case ComponentColumnHeader.Link:
                {
                    let value = this.getComponentLife(ComponentType.Link, side, components, 1);

                    if(value ==-1.10101){
                        if(side==1) row.W_LinkL='-';
                        else row.W_LinkR='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_LinkL=value.toString();
                        else row.W_LinkR=value.toString();
                        return  value.toString();
                    }
                }
            case ComponentColumnHeader.TrackElon:
                {
                        let value = this.getComponentLife(ComponentType.TrackElongation, side, components, 1);
    
                        if(value ==-1.10101){
                            if(side==1) row.W_TrackElonL='-';
                            else row.W_TrackElonR='-';
                            return  '-';
                        }else{
                            if(side==1) row.W_TrackElonL=value.toString();
                            else row.W_TrackElonR=value.toString();
                            return  value.toString();
                        }
                }
               
               // return ((this.getComponentLife(ComponentType.Link, side, components, 1) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.Link, side, components, 1)).toString()); //.toString();
            case ComponentColumnHeader.Bush:
                {
                    let value =this.getComponentLife(ComponentType.Bushing, side, components, 1);

                    if(value ==-1.10101){
                        if(side==1) row.W_BushL='-';
                        else row.W_BushR='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_BushL=value.toString();
                        else row.W_BushR=value.toString();
                        return  value.toString();
                    }
                }
                
                //return ((this.getComponentLife(ComponentType.Bushing, side, components, 1) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.Bushing, side, components, 1)).toString()); //.toString();
            case ComponentColumnHeader.Shoe:
                {
                    let value =this.getComponentLife(ComponentType.Shoe, side, components, 1);

                    if(value ==-1.10101){
                        if(side==1) row.W_ShoeL='-';
                        else row.W_ShoeR='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_ShoeL=value.toString();
                        else row.W_ShoeR=value.toString();
                        return  value.toString();
                    }
                }
               // return ((this.getComponentLife(ComponentType.Shoe, side, components, 1) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.Shoe, side, components, 1)).toString()); //.toString();
            case ComponentColumnHeader.FrontIdler:
                {
                    let value =this.getComponentLife(ComponentType.Idler, side, components, 1);

                    if(value ==-1.10101){
                        if(side==1) row.W_FIdlerL='-';
                        else row.W_FIdlerR='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_FIdlerL=value.toString();
                        else row.W_FIdlerR=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.Idler, side, components, 1) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.Idler, side, components, 1)).toString()); //.toString();
            case ComponentColumnHeader.RearIdler:
                {
                    let value =this.getComponentLife(ComponentType.Idler, side, components, 1);

                    if(value ==-1.10101){
                        if(side==1) row.W_RIdlerL='-';
                        else row.W_RIdlerR='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_RIdlerL=value.toString();
                        else row.W_RIdlerR=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.Idler, side, components, 2) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.Idler, side, components, 2)).toString()); //.toString();
            case ComponentColumnHeader.Sprocket:
                {
                    let value =this.getComponentLife(ComponentType.Sprocket, side, components, 1);

                    if(value ==-1.10101){
                        if(side==1) row.W_SprocketL='-';
                        else row.W_SprocketR='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_SprocketL=value.toString();
                        else row.W_SprocketR=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.Sprocket, side, components, 1) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.Sprocket, side, components, 1)).toString()); //.toString();
            case ComponentColumnHeader.CarrierRoller_1:
                {
                    let value =this.getComponentLife(ComponentType.CarrierRoller, side, components, 1);

                    if(value ==-1.10101){
                        if(side==1) row.W_CR1L='-';
                        else row.W_CR1R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_CR1L=value.toString();
                        else row.W_CR1R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.CarrierRoller, side, components, 1) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.CarrierRoller, side, components, 1)).toString()); //.toString();
            case ComponentColumnHeader.CarrierRoller_2:
                {
                    let value =this.getComponentLife(ComponentType.CarrierRoller, side, components, 2);

                    if(value ==-1.10101){
                        if(side==1) row.W_CR2L='-';
                        else row.W_CR2R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_CR2L=value.toString();
                        else row.W_CR2R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.CarrierRoller, side, components, 2) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.CarrierRoller, side, components, 2)).toString()); //.toString();
            case ComponentColumnHeader.CarrierRoller_3:
                {
                    let value =this.getComponentLife(ComponentType.CarrierRoller, side, components, 3);

                    if(value ==-1.10101){
                        if(side==1) row.W_CR3L='-';
                        else row.W_CR3R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_CR3L=value.toString();
                        else row.W_CR3R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.CarrierRoller, side, components, 3) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.CarrierRoller, side, components, 3)).toString()); //.toString();
            case ComponentColumnHeader.CarrierRoller_4:
                {
                    let value =this.getComponentLife(ComponentType.CarrierRoller, side, components, 4);

                    if(value ==-1.10101){
                        if(side==1) row.W_CR4L='-';
                        else row.W_CR4R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_CR4L=value.toString();
                        else row.W_CR4R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.CarrierRoller, side, components, 4) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.CarrierRoller, side, components, 4)).toString()); //.toString();
            case ComponentColumnHeader.CarrierRoller_5:
                {
                    let value =this.getComponentLife(ComponentType.CarrierRoller, side, components, 5);

                    if(value ==-1.10101){
                        if(side==1) row.W_CR5L='-';
                        else row.W_CR5R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_CR5L=value.toString();
                        else row.W_CR5R=value.toString();
                        return  value.toString();
                    }
                }
               // return ((this.getComponentLife(ComponentType.CarrierRoller, side, components, 5) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.CarrierRoller, side, components, 5)).toString()); //.toString();

            case ComponentColumnHeader.TrackRoller_1:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 1);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR1L='-';
                        else row.W_TR1R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR1L=value.toString();
                        else row.W_TR1R=value.toString();
                        return  value.toString();
                    }
                }
               // return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 1) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 1)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_2:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 2);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR2L='-';
                        else row.W_TR2R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR2L=value.toString();
                        else row.W_TR2R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 2) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 2)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_3:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 3);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR3L='-';
                        else row.W_TR3R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR3L=value.toString();
                        else row.W_TR3R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 3) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 3)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_4:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 4);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR4L='-';
                        else row.W_TR4R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR4L=value.toString();
                        else row.W_TR4R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 4) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 4)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_5:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 5);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR5L='-';
                        else row.W_TR5R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR5L=value.toString();
                        else row.W_TR5R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 5) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 5)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_6:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 6);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR6L='-';
                        else row.W_TR6R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR6L=value.toString();
                        else row.W_TR6R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 6) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 6)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_7:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 7);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR7L='-';
                        else row.W_TR7R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR7L=value.toString();
                        else row.W_TR7R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 7) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 7)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_8:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 8);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR8L='-';
                        else row.W_TR8R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR8L=value.toString();
                        else row.W_TR8R=value.toString();
                        return  value.toString();
                    }
                }
               // return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 8) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 8)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_9:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 9);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR9L='-';
                        else row.W_TR9R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR9L=value.toString();
                        else row.W_TR9R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 9) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 9)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_10:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 10);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR10L='-';
                        else row.W_TR10R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR10L=value.toString();
                        else row.W_TR10R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 10) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 10)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_11:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 11);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR11L='-';
                        else row.W_TR11R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR11L=value.toString();
                        else row.W_TR11R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 11) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 11)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_12:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 12);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR12L='-';
                        else row.W_TR12R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR12L=value.toString();
                        else row.W_TR12R=value.toString();
                        return  value.toString();
                    }
                }
               // return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 12) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 12)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_13:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 13);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR13L='-';
                        else row.W_TR13R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR13L=value.toString();
                        else row.W_TR13R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 13) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 13)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_14:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 14);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR14L='-';
                        else row.W_TR14R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR14L=value.toString();
                        else row.W_TR14R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 14) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 14)).toString()); //.toString();
            case ComponentColumnHeader.TrackRoller_15:
                {
                    let value =this.getComponentLife(ComponentType.TrackRoller, side, components, 15);

                    if(value ==-1.10101){
                        if(side==1) row.W_TR15L='-';
                        else row.W_TR15R='-';
                        return  '-';
                    }else{
                        if(side==1) row.W_TR15L=value.toString();
                        else row.W_TR15R=value.toString();
                        return  value.toString();
                    }
                }
                //return ((this.getComponentLife(ComponentType.TrackRoller, side, components, 15) == -1.10101) ? '-' : (this.getComponentLife(ComponentType.TrackRoller, side, components, 15)).toString()); //.toString();


            default:
                return '';
        }
    }
    public x: any
    public y: any
    worn:any
    private getComponentworn(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, CalcAvg: boolean, track: boolean): number {

        let comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side);
        if (position != 0)
            comps = comps.filter(m => m.Position == position);
        if (comps.length == 0) return 0;
        if (CalcAvg) {
            let sum = 0;
            for (let i = 0; i < comps.length; i++) {
                sum += comps[i].Worn;
            }
            const avg = sum / comps.length;
            return Math.round(avg * 100) / 100;
        }
        else if (!track) {
          //  return Math.round(Math.max(...comps.map(m => m.Worn)) * 100) / 100;
          let precetage = Math.round(Math.max(...comps.map(m => m.Worn)) * 100) / 100;
          this.worn =  precetage.toFixed(1);
            return this.worn;
        }
        this.x = comps.map(m => m.Worn).join('% ').concat('% ')
        return this.x

    }
    private getComponentLife(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number): number {
        const comp = components.find(m => m.Compart.CompartType.Id === componentType && m.Side === side && m.Position === position);
        if (!comp) {
            return -1.10101;
        }
        else {
            let budgetLife = comp.Compart.BudgetLife;
            let projectHours = comp.ProjectedHours;
            var result = projectHours - budgetLife;
        }
        
        return result;
    }

    getComponentClass(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[]): string {
        let worn = 0;
        switch (componentHeader) {
            case ComponentColumnHeader.Link:
                worn = this.getComponentworn(ComponentType.Link, side, components, 1, false, false);
                break;
            case ComponentColumnHeader.Bush:
                worn = this.getComponentworn(ComponentType.Bushing, side, components, 1, false, false);
                break;
            case ComponentColumnHeader.BushTurned:
                return 'actions';
            case ComponentColumnHeader.Shoe:
                worn = this.getComponentworn(ComponentType.Shoe, side, components, 1, false, false);
                break;
            case ComponentColumnHeader.FrontIdler:
                worn = this.getComponentworn(ComponentType.Idler, side, components, 1, false, false);
                break;
            case ComponentColumnHeader.RearIdler:
                worn = this.getComponentworn(ComponentType.Idler, side, components, 2, false, false);
                break;
            case ComponentColumnHeader.Sprocket:
                worn = this.getComponentworn(ComponentType.Sprocket, side, components, 1, false, false);
                break;
            case ComponentColumnHeader.CarrierRoller_1:
                worn = this.getComponentworn(ComponentType.CarrierRoller, side, components, 1, false, false);
                break;
            case ComponentColumnHeader.CarrierRoller_2:
                worn = this.getComponentworn(ComponentType.CarrierRoller, side, components, 2, false, false);
                break;

            case ComponentColumnHeader.CarrierRoller_3:
                worn = this.getComponentworn(ComponentType.CarrierRoller, side, components, 3, false, false);
                break;
            case ComponentColumnHeader.CarrierRoller_4:
                worn = this.getComponentworn(ComponentType.CarrierRoller, side, components, 4, false, false);
                break;
            case ComponentColumnHeader.CarrierRoller_5:
                worn = this.getComponentworn(ComponentType.CarrierRoller, side, components, 5, false, false);
                break;

            case ComponentColumnHeader.TrackRoller_1:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 1, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_2:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 2, false, false);
                break;

            case ComponentColumnHeader.TrackRoller_3:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 3, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_4:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 4, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_5:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 5, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_6:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 6, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_7:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 7, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_8:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 8, false, false);
                break;
                case ComponentColumnHeader.TrackRoller_9:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 9, false, false);
                break;

            case ComponentColumnHeader.TrackRoller_10:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 10, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_11:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components,11, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_12:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 12, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_13:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 13, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_14:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 14, false, false);
                break;
            case ComponentColumnHeader.TrackRoller_15:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 15, false, false);
                break;
                case ComponentColumnHeader.TrackElon:
                    worn = this.getComponentworn(ComponentType.TrackElongation, side, components, 1, false, false);
                    break;

            case ComponentColumnHeader.Sides:
                return 'label';
            default:
                return 'u-bg';
        }
        if (worn <= 30) return ' a-bg';
        if (worn <= 50) return ' b-bg';
        if (worn <= 70) return ' c-bg';
        return ' x-bg';
    }

    getComponentLifeDifference(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number): number {
        const comp = components.find(m => m.Compart.CompartType.Id === componentType && m.Side === side && m.Position === position);
        if (!comp) {
            //return -1.10101;
           return 0;
        }
        else {
            let budgetLife = comp.Compart.BudgetLife;
            let projectHours = comp.ProjectedHours;
           // var result = (projectHours - budgetLife)/budgetLife*100;
           var diff = (projectHours - budgetLife);
var result;
           let twopercent = ((budgetLife*2)/100)*-1;
           let fivepercent = ((budgetLife*5)/100)*-1;
           let tenpercent = ((budgetLife*10)/100)*-1;

           if(diff > twopercent){
                result = 1;
           }
           if(diff > fivepercent && diff <= twopercent){
            result = 2;
            }
            if(diff > tenpercent && diff <= fivepercent){
                result = 3;
            }
           if(diff <= tenpercent){
            result = 4;
            }
           

         
        }
        return result;
    }
    getComponentHoursClass(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[]): string {
        var worn = 0;
        switch (componentHeader) {
            case ComponentColumnHeader.Link:
                worn = this.getComponentLifeDifference(ComponentType.Link, side, components, 1);
                break;
            case ComponentColumnHeader.Bush:
                worn = this.getComponentLifeDifference(ComponentType.Bushing, side, components, 1);
                break;
            case ComponentColumnHeader.BushTurned:
                return 'actions';
            case ComponentColumnHeader.Shoe:
                worn = this.getComponentLifeDifference(ComponentType.Shoe, side, components, 1);
                break;
            case ComponentColumnHeader.FrontIdler:
                worn = this.getComponentLifeDifference(ComponentType.Idler, side, components, 1);
                break;
            case ComponentColumnHeader.RearIdler:
                worn = this.getComponentLifeDifference(ComponentType.Idler, side, components, 2);
                break;
            case ComponentColumnHeader.Sprocket:
                worn = this.getComponentLifeDifference(ComponentType.Sprocket, side, components, 1);
                break;
            case ComponentColumnHeader.CarrierRoller_1:
                worn = this.getComponentLifeDifference(ComponentType.CarrierRoller, side, components, 1);
                break;
            case ComponentColumnHeader.CarrierRoller_2:
                worn = this.getComponentLifeDifference(ComponentType.CarrierRoller, side, components, 2);
                break;

            case ComponentColumnHeader.CarrierRoller_3:
                worn = this.getComponentLifeDifference(ComponentType.CarrierRoller, side, components, 3);
                break;
            case ComponentColumnHeader.CarrierRoller_4:
                worn = this.getComponentLifeDifference(ComponentType.CarrierRoller, side, components, 4);
                break;
            case ComponentColumnHeader.CarrierRoller_5:
                worn = this.getComponentLifeDifference(ComponentType.CarrierRoller, side, components, 5);
                break;

            case ComponentColumnHeader.TrackRoller_1:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 1);
                break;
            case ComponentColumnHeader.TrackRoller_2:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 2);
                break;
            case ComponentColumnHeader.TrackRoller_3:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 3);
                break;
            case ComponentColumnHeader.TrackRoller_4:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 4);
                break;
            case ComponentColumnHeader.TrackRoller_5:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 5);
                break;
            case ComponentColumnHeader.TrackRoller_6:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 6);
                break;
            case ComponentColumnHeader.TrackRoller_7:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 7);
                break;
            case ComponentColumnHeader.TrackRoller_8:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 8);
                break;
                case ComponentColumnHeader.TrackRoller_9:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 9);
                break;
            case ComponentColumnHeader.TrackRoller_10:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 10);
                break;
            case ComponentColumnHeader.TrackRoller_11:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 11);
                break;
            case ComponentColumnHeader.TrackRoller_12:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 12);
                break;
            case ComponentColumnHeader.TrackRoller_13:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 13);
                break;
            case ComponentColumnHeader.TrackRoller_14:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 14);
                break;
            case ComponentColumnHeader.TrackRoller_15:
                worn = this.getComponentLifeDifference(ComponentType.TrackRoller, side, components, 15);
                break;
            case ComponentColumnHeader.TrackElon:
                    worn = this.getComponentLifeDifference(ComponentType.TrackElongation, side, components, 1);
                    break;

            case ComponentColumnHeader.Sides:
                return 'label';
            default:
                return 'u-bg';
        }

        let worn_ = Math.abs(worn)
        if (worn_ == 0) return 'u-bg';
        if (worn_ == 1) return ' a-bg';
        if (worn_ == 2) return ' b-bg';
        if (worn_ == 3) return ' c-bg';
        return ' x-bg';


      
    }
    

    private checkComponetAction(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, actionTypeId: number): boolean {
        const comp = components.find(m => m.Compart.CompartType.Id === componentType && m.Side === side && m.Position === position);
        if (!comp) return false;
        const action = comp.Actions.find(m => m.ActionType === actionTypeId);
        if (action) return true;
        return false;
    }
    getNextInspectionCSSClass(dateStr: string): string {
        return this._moduleService.getNextInspectionCSSClass(dateStr);
    }
    getOutstandingActions(side: Side, components: ComponentViewViewModel[], recommendedActions: ComponentActionViewModel[]): string {
        const comps = components.filter(m => m.Side === side);
        let remainingActions = recommendedActions.length;
        for (const cmp of comps) {
            for (const act of cmp.Actions) {
                if (recommendedActions.findIndex(m => m.ComponentId === act.ComponentId && m.ActionType === act.ActionType) >= 0)
                    remainingActions--;
            }
        }
        return remainingActions + '/' + recommendedActions.length;
    }
    mouseClientX = '';
    mouseClientY_Top = '';
    mouseClientY_Bottom = '';
    displayActionPopUp = false;
    actionStatusTable: OutstantingActionStatus[] = [];
    mouseOverAction(event: any, row: ComponentTableInspectionViewModel, side: Side) {
        this.actionStatusTable = [];
        this.actionStatusTable = this.getOutstandingTable(row.Components.filter(m => m.Side === side), row.LastInspection.RecommendedActions);
        if (this.actionStatusTable.length === 0) {
            this.displayActionPopUp = false;
            return;
        }
        this.mouseClientX = (event.clientX - 365).toString() + 'px';
        const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if (event.clientY > h / 2) {
            this.mouseClientY_Bottom = (h - event.clientY).toString() + 'px';
            this.mouseClientY_Top = 'auto';
        }
        else {
            this.mouseClientY_Top = event.clientY + 'px';
            this.mouseClientY_Bottom = 'auto';
        }

        this.displayActionPopUp = true;
    }
    closeActionPopUp() {
        this.actionStatusTable = [];
        this.displayActionPopUp = false;
    }

    mouseleaverAction() {
        this.actionStatusTable = [];
        this.displayActionPopUp = false;
    }
    //Get trackroller frme values 
    trackRollerWorn: TrackRollerWorn[]
    displaytrackPopUp: boolean = false;
    evalclass: string
    side_eval
    trackRollerVAl: number[]
    trackPosition: ComponentViewViewModel[]
    mouseOverTrackRollers(event: any, row: ComponentTableInspectionViewModel, side: Side) {
        if (ComponentType.TrackRoller)
            this.trackRollerVAl = this.getComponentTrackworn_(ComponentType.TrackRoller, side, row.Components, 0, false, true);
        this.trackPosition = this.getComponentTrackPosition_(ComponentType.TrackRoller, side, row.Components, 0, false, true);

        if (side == 1)
            this.side_eval = "Left Side"
        else
            this.side_eval = "Right Side"

        if (this.trackRollerVAl.length == 0) {
            this.displaytrackPopUp = false;
            return;
        }
        this.mouseClientX = (event.clientX - 365).toString() + 'px';
        var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if (event.clientY > h / 2) {
            this.mouseClientY_Bottom = (h - event.clientY).toString() + 'px';
            this.mouseClientY_Top = "auto";
        }
        else {
            this.mouseClientY_Top = event.clientY + 'px';
            this.mouseClientY_Bottom = "auto";
        }
        this.displaytrackPopUp = true;
    }
    closetrackPopUp() {
        this.trackRollerWorn = [];
        this.displaytrackPopUp = false;
    }
    mouseleaveTrackRollers() {
        this.trackRollerWorn = [];
        this.displaytrackPopUp = false;
    }

    private getComponentTrackworn_(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, CalcAvg: boolean, track: boolean): number[] {
        let arraytrack: number[]

        var value = 0;
        let comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side);
        if (position != 0)
            comps = comps.filter(m => m.Position == position);
        if (comps.length == 0) return [];
        arraytrack = comps.map(m => m.Worn)
        return arraytrack

    }
    private getComponentTrackPosition_(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, CalcAvg: boolean, track: boolean): ComponentViewViewModel[] {

        let arrayPosition: ComponentViewViewModel[]
        var value = 0;
        let comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side);
        if (position != 0)
            comps = comps.filter(m => m.Position == position);
        if (comps.length == 0) return [];
        arrayPosition = comps
        return arrayPosition

    }

    getComponentTrackClass(worn: number): string {
        if (worn <= 30) return ' a-bg';
        if (worn <= 50) return ' b-bg';
        if (worn <= 70) return ' c-bg';
        return ' x-bg';
    }
    private getOutstandingTable(components: ComponentViewViewModel[], actions: ComponentActionViewModel[]): OutstantingActionStatus[] {
        const result: OutstantingActionStatus[] = [];
        // console.log(components, actions);
        for (const action of actions) {
            const current: OutstantingActionStatus = new OutstantingActionStatus();
            current.ComponentId = action.ComponentId;
            current.ActionType = action.ActionType;
            current.ActionTitle = this._appService.getActionTitle(action.ActionType);
            const comp = components.find(m => m.Id === action.ComponentId);
            if (comp && comp.Actions.filter(m => m.ActionType === action.ActionType).length > 0) {
                current.ActionStatus = this.Translate('Done');
                current.CssClass = 'Eval-A';
            } else {
                current.ActionStatus = this.Translate('Outstanding');
                current.CssClass = 'Eval-X';
            }
            result.push(current);
        }
        return result;
    }
    sortChanged(sort: Sort) {
        if (this._currentSort.active !== sort.active)
            this.loadingPage = 1;
        this._currentSort = sort;
        this.retrieveEquipmentsComponentViewBySearchItems(this.loadingPage, this.loadSize);
    }

    printBySearchId(searchId: number) {
        if (searchId > 0)
            window.open('components-print/' + searchId, '_blank');
        //    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
        //     if(res=="True"){
        //       this._router.navigate(['/components-print', searchId]);
        //     }else{             
        //         window.open('components-print/' + searchId, '_blank');
             
        //     }
        // });
        else {
            this._notification.warn(this.Translate('Operation Failed!'), this.Translate('Something went wrong with current search, please check log!'));
            console.error('Saving current search to database failed!');
        }
    }
}


///End of component class

export class EqTableDatabase {
    dataChange: BehaviorSubject<equipmentVwMdl[]> = new BehaviorSubject<equipmentVwMdl[]>([]);
    get data(): equipmentVwMdl[] { return this.dataChange.value; }
    constructor(_equipmentList: equipmentVwMdl[]) {
        this.dataChange.next(_equipmentList);
    }
}

export class EqTableDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    get filter(): string { return this._filterChange.value; }
    set filter(filter: string) { this._filterChange.next(filter); }
    customerId = 0;
    jobsiteId = 0;
    equipmentId = 0;
    familyId = 0;
    makeId = 0;
    modelId = 0;
    constructor(private _exampleDatabase: EqTableDatabase, private _paginator: MatPaginator) {
        super();
    }
    public selectionUpdated(customer: number, jobsite: number, equipment: number, family: number, make: number, model: number) {
        this.customerId = customer;
        this.jobsiteId = jobsite;
        this.equipmentId = equipment;
        this.familyId = family;
        this.makeId = make;
        this.modelId = model;
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<equipmentVwMdl[]> {
        const displayDataChanges = [
            this._exampleDatabase.dataChange,
            this._paginator.page,
            this._filterChange,
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            const data = this._exampleDatabase.data.slice().filter(
                (item: equipmentVwMdl) => {
                    const searchSerial = (item.serial).toLowerCase();
                    const searchUnit = (item.unit).toLowerCase();
                    const searchCustomer = (item.customerName).toLowerCase();
                    const searchMake = (item.make).toLowerCase();
                    const searchModel = (item.model).toLowerCase();
                    const searchFamily = (item.family).toLowerCase();
                    if (this.customerId && item.customerId !== this.customerId)
                        return false;
                    if (this.jobsiteId && item.jobsiteId !== this.jobsiteId)
                        return false;
                    if (this.equipmentId && item.Id !== this.equipmentId)
                        return false;
                    if (this.familyId && item.familyId !== this.familyId)
                        return false;
                    if (this.makeId && item.makeId !== this.makeId)
                        return false;
                    if (this.modelId && item.modelId !== this.modelId)
                        return false;
                    return (searchSerial.indexOf(this.filter.toLowerCase()) !== -1
                        || searchUnit.indexOf(this.filter.toLowerCase()) !== -1
                        || searchCustomer.indexOf(this.filter.toLowerCase()) !== -1
                        || searchMake.indexOf(this.filter.toLowerCase()) !== -1
                        || searchModel.indexOf(this.filter.toLowerCase()) !== -1
                        || searchFamily.indexOf(this.filter.toLowerCase()) !== -1
                    );
                }
            );

            // Grab the page's slice of data.
            // const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            // return data.splice(startIndex, this._paginator.pageSize);
            return data;
        });
    }

    disconnect() { }
}

export class ComponentViewTableDatabase {
    dataChange: BehaviorSubject<ComponentTableInspectionViewModel[]> = new BehaviorSubject<ComponentTableInspectionViewModel[]>([]);
    get data(): ComponentTableInspectionViewModel[] { return this.dataChange.value; }
    constructor(_equipmentList: ComponentTableInspectionViewModel[]) {
        this.dataChange.next(_equipmentList);
    }
}

export class ComponentViewTableDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    get filter(): string { return this._filterChange.value; }
    set filter(filter: string) { this._filterChange.next(filter); }
    constructor(private _componentDatabase: ComponentViewTableDatabase, private _paginator: MatPaginator) {
        super();
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<ComponentTableInspectionViewModel[]> {
        const displayDataChanges = [
            this._componentDatabase.dataChange,
            this._paginator.page,
            this._filterChange,
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            const data = this._componentDatabase.data.slice().filter(
                (item: ComponentTableInspectionViewModel) => {
                    const searchSerial = (item.Equipment.Serial).toLowerCase();
                    const searchUnit = (item.Equipment.Unit).toLowerCase();
                    return (searchSerial.indexOf(this.filter.toLowerCase()) !== -1
                        || searchUnit.indexOf(this.filter.toLowerCase()) !== -1
                    );
                }
            );
            return data;
        });
    }

    disconnect() { }
}
